import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import HomeIcon from '@material-ui/icons/Home';
import AccountCircleIcon from '@material-ui/icons//AccountCircle';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Typography from '@material-ui/core/Typography';
import useAuth from '../auth/context/auth';
import './Header.css';

const useStyles = makeStyles((theme) => ({
  header: {
    background: '#006bb6',
  },
  emptyTitleToTakeSpace: {
    flexGrow: 1,
  },
  titleSpan: {
    cursor: 'pointer',
  },
  offset: theme.mixins.toolbar,
}));

const Header = () => {
  const classes = useStyles();
  const { user } = useAuth();
  const history = useHistory();
  const location = useLocation();

  const logOut = () => {
    Auth.signOut();
    localStorage.removeItem('nss_user');
    localStorage.removeItem('nss_user_attributes');
  };

  const isLoggedIn = user;

  return (
    <>
      <AppBar position="fixed">
        <Toolbar className={classes.header}>
          <svg className="shape">
            <polygon points="100,0 3000,0 3000,100 0,100" />
          </svg>
          <Typography variant="h4" className={classes.emptyTitleToTakeSpace}>
            <span
              className={classes.titleSpan}
              onClick={() => history.push('/')}
              role="none"
            >
              NSS Talent Marketplace
            </span>
          </Typography>
          <div>
            <IconButton
              aria-label="Home"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={() => {
                history.push('/');
              }}
              color="inherit"
            >
              <HomeIcon />
            </IconButton>

            {isLoggedIn ? (
              <IconButton
                aria-label="Exit App"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={() => {
                  logOut();
                }}
                color="inherit"
              >
                <ExitToAppIcon />
              </IconButton>
            ) : (
              <IconButton
                aria-label="Exit App"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={() => {
                  history.push({
                    pathname: '/login',
                    state: { referer: location.pathname },
                  });
                }}
                color="inherit"
              >
                <AccountCircleIcon />
              </IconButton>
            )}
          </div>
        </Toolbar>
      </AppBar>
      <div className={classes.offset} />
    </>
  );
};

export default Header;
